export default __webpack_public_path__ + "static/GothamNarrowBoldItalic-953a2127dded128bd46b79a7ce0b4c1b.eot";